import { render, staticRenderFns } from "./agmForm.vue?vue&type=template&id=536b8c65&scoped=true&"
import script from "./agmForm.vue?vue&type=script&lang=js&"
export * from "./agmForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536b8c65",
  null
  
)

export default component.exports